export function mapCompanyType(code: number): string | null {
  let companyType;

  switch (code) {
    case 2038: // Sociedade Anônima
      companyType = 'SA';
      break;
    case 2062: // Sociedade Empresária Limitada
    case 2135: // Sociedade Simples Limitada
      companyType = 'LTDA';
      break;
    case 2136: // Empresário (MEI)
      companyType = 'MEI';
      break;
    case 2137: // Microempresa
    case 2138: // Empresa de Pequeno Porte
      companyType = 'ME';
      break;
    case 2305: // Empresa Individual de Responsabilidade Limitada (EIRELI)
      companyType = 'EIRELI';
      break;
    default:
      companyType = null; // Código não reconhecido
      break;
  }

  return companyType;
}

export enum RecipientBusinessArea {
  ECOMMERCE = 'ecommerce',
  SOFTWARE_AS_A_SERVICE = 'software_as_a_service',
  SUBSCRIPTION_SERVICE = 'subscription_service',
  PAYMENT_FACILITATION = 'payment_facilitation',
  PAYMENT_GATEWAY = 'payment_gateway',
  ONLINE_BETTING = 'online_betting',
  RELIGIOUS_ENTITIES = 'religious_entities',
  LUXURY_ITEMS = 'luxury_items',
  TICKETING = 'ticketing',
  CONSULTING = 'consulting',
  TRAVEL_TOURISM = 'travel_tourism',
  CRYPTO = 'crypto',
  ADULT_ENTERTAINMENT = 'adult_entertainment',
  OTHER = 'other',
}
